import { Button } from '@mui/material'

interface DownloadAppProps {
    image: string
    alt: string
    onClick: () => void
}

const DownloadApp: React.FC<DownloadAppProps> = ({ image, alt, onClick }) => {
    return (
        <Button
            variant="contained"
            size="large"
            onClick={onClick}
            sx={{
                backgroundColor: '#000',
                color: '#ffffff',
                border: '2px solid #B7B7B7',
                borderRadius: '6px',
                '&:hover': {
                    backgroundColor: '#1a1a1a',
                },
            }}
        >
            <img src={image} alt={alt} style={{ height: '100%', width: '100%' }} />
        </Button>
    )
}

export default DownloadApp
